import React, { useState } from "react";

import Table from "../../components/Table";
import { Box, Button, TextField } from "@mui/material";
import { toRegulerCase } from "../../utils/Utils";
import { handleDjangoDataRequest } from "../../utils/apiUtils";
import TableSkeleton from "../../components/TableSkeleton";

import moment from "moment";
import Nodata from "../../components/Nodata";

export default function UsageLog({ hotelId }) {
  const [rowData, setRowData] = useState();

  const [columnDefs, setColumnDefs] = useState();
  const handleColumn = (data) => {
    if (data) {
      const culumnData = Object.keys(data[0]).map((elm) => ({
        field: elm,
        headerName: toRegulerCase(elm),
      }));
      setColumnDefs(culumnData);
    }
  };

  //-------------------
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const [queried, setQueried] = useState(false);

  const handleShowButton = () => {
    setLoading(true);
    setQueried(true);
    const dateObj = moment(selectedDate, "YYYY-MM-DD");
    const formatedDate = `${dateObj.format("MMMM")}%20${dateObj.format("D")}%2C%20${dateObj.format("YYYY")}%20-%20${dateObj.format("MMMM")}%20${dateObj.format("D")}%2C%20${dateObj.format("YYYY")}`;
    handleDjangoDataRequest(
      `api/v2/metaAdmin/metaGetUsageLogsForHotel/?hotel_id=${hotelId}&daterange=${formatedDate}`,
    )
      .then((data) => {
        setLoading(false);
        handleColumn(data);
        setRowData(data);
      })
      .catch((err) => setLoading(false));
  };

  return (
    <>
      <Box sx={{ display: "flex", marginBottom: 1, alignItems: "center" }}>
        <TextField
          label="Date"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          size="small"
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: moment().format("YYYY-MM-DD") }}
          sx={{ width: 160 }}
        />
        <Button
          variant="custom-button"
          sx={{ ml: 2 }}
          onClick={handleShowButton}
        >
          Show Data
        </Button>
      </Box>
      {loading ? (
        <TableSkeleton />
      ) : queried ? (
        rowData ? (
          <Table rowData={rowData} columnDefs={columnDefs} />
        ) : (
          <Nodata />
        )
      ) : null}
    </>
  );
}
